import { useArticles } from "@faire/help-center-utils/hooks/article/useArticles";
import { useStrictLocalization } from "@faire/web/common/localization";
import { Synchronized } from "@faire/web/slate/icons/foundation/Synchronized";
import React from "react";
export var useIntegrationsBrandNodes = function useIntegrationsBrandNodes() {
  var _useStrictLocalizatio = useStrictLocalization(),
    strictLocalize = _useStrictLocalizatio.strictLocalize;
  var articles = useArticles();
  return {
    Integrations: {
      id: "Integrations",
      label: strictLocalize({
        id: "oogQe8",
        defaultMessage: [{
          "type": 0,
          "value": "Intégrations"
        }]
      }),
      icon: /*#__PURE__*/React.createElement(Synchronized, {
        fontSize: "24px",
        color: "faireBlack"
      }),
      articles: [articles.Integration.SOFTWARE_INTEGRATION_WITH_FAIRE, articles.Integration.ONBOARDING_WITH_SHOPIFY, articles.Integration.CAN_I_INTEGRATE_WITH_SHOPIFY],
      level: 1,
      sidebarTitle: strictLocalize({
        id: "nD5YF3",
        defaultMessage: [{
          "type": 0,
          "value": "Problème concernant une intégration"
        }]
      })
    }
  };
};